import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import * as styles from './footer.module.css'
import SynapseLogo from '../icons/SynapseLogo'
import { getTextCopy, getLinkPath } from '../../helpers'

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      footerComponent: contentfulComponent(name: { eq: "component.footer" }) {
        ...componentFields
      }
      footerLeftNavMenu: contentfulNavMenu(key: { eq: "nav.footerLeft" }) {
        ...navMenuFields
      }
      footerCenterNavMenu: contentfulNavMenu(key: { eq: "nav.footerCenter" }) {
        ...navMenuFields
      }
      footerRightNavMenu: contentfulNavMenu(key: { eq: "nav.footerRight" }) {
        ...navMenuFields
      }
      homePage: contentfulPage(name: { eq: "page.home" }) {
        homePageSlug: slug
      }
    }
  `)
  const { content } = data.footerComponent
  const footerLeftNavMenu = data.footerLeftNavMenu
  const footerCenterNavMenu = data.footerCenterNavMenu
  const footerRightNavMenu = data.footerRightNavMenu

  const { homePageSlug } = data.homePage

  const copyrightYear = new Date().getFullYear()
  const copyright = getTextCopy(content, 'component.footer.copyright')
    .replace(`{{copyrightYear}}`, copyrightYear)

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        <Link to={homePageSlug}>
          <SynapseLogo fill="#fff" />
        </Link>
        <div className={styles.footerContent}>
          <div key={footerLeftNavMenu.name} className={styles.footerColumn}>
            <div className={styles.footerColumnTitle}>
              {footerLeftNavMenu.name}
            </div>
            <div className={styles.footerColumnLinks}>
              {footerLeftNavMenu.links.map(link => (
                <Link key={link.title} to={getLinkPath(link)}>
                  {link.title}
                </Link>
              ))}
            </div>
          </div>

          <div key={footerCenterNavMenu.name} className={styles.footerColumn}>
            <div className={styles.footerColumnTitle}>
              {footerCenterNavMenu.name}
            </div>
            <div className={styles.footerColumnLinks}>
              {footerCenterNavMenu.links.map(link => (
                <Link key={link.title} to={getLinkPath(link)}>
                  {link.title}
                </Link>
              ))}
            </div>
          </div>

          <div key={footerRightNavMenu.name} className={styles.footerColumn}>
            <div className={styles.footerColumnTitle}>
              {footerRightNavMenu.name}
            </div>
            <div className={styles.footerColumnLinks}>
              {footerRightNavMenu.links.map(link => (
                <Link key={link.title} to={getLinkPath(link)}>
                  {link.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.footerFooter}>
          {copyright}
        </div>
      </div>
    </div>
  )
}

export default Footer
